import { takeUntil } from 'rxjs';

import { CommonModule } from '@angular/common';
import { Component, EventEmitter, inject, Input, OnDestroy, OnInit } from '@angular/core';
import { IInventoryLocation, IInventoryLocationItemWithData } from '@inventory/models/inventory';
import { InventoryItemsLocationsService } from '@inventory/services/inventory-items-locations/inventory-items-locations.service';
import { LoadingStateComponent } from '@shared/components/loading-state/loading-state.component';
import { NullDefaultPipe } from '@shared/pipes/null-default.pipe';
import { OffcanvasService } from '@shared/services/offcanvas/offcanvas.service';

@Component({
	selector: 'app-inventory-items-by-location-offcanvas',
	imports: [CommonModule, LoadingStateComponent, NullDefaultPipe],
	templateUrl: './inventory-items-by-location-offcanvas.component.html',
	styleUrl: './inventory-items-by-location-offcanvas.component.scss',
	host: {
		class: 'h-100',
		style: 'display: contents',
	},
})
export class InventoryItemsByLocationOffcanvasComponent implements OnInit, OnDestroy {
	@Input() inventoryLocation: IInventoryLocation;

	private inventoryItemsLocationsService = inject(InventoryItemsLocationsService);
	private offcanvasService = inject(OffcanvasService);

	inventoryItemLocations: Array<IInventoryLocationItemWithData> = [];
	destroyed$: EventEmitter<void> = new EventEmitter<void>();
	isLoading = true;

	ngOnInit(): void {
		this.inventoryItemsLocationsService
			.getInventoryItemLocationsWithDataForLocation(this.inventoryLocation.organisation, this.inventoryLocation.id!)
			.pipe(takeUntil(this.destroyed$))
			.subscribe((itemLocations) => {
				this.inventoryItemLocations = itemLocations;
				this.isLoading = false;
			});
	}

	close(): void {
		this.offcanvasService.dismissLast();
	}

	ngOnDestroy(): void {
		this.destroyed$.emit();
	}
}
